import { useEffect, useState } from "react";
import { fetchWebPosts } from "../api/webpage";
import { listCmsDocuments, postPath } from "../data/cmsPublic";

const inFlight = new Map();

function loadPublicWebPosts(params) {
  const key = JSON.stringify(params || {});
  if (!inFlight.has(key)) {
    const promise = fetchWebPosts(params)
      .then((response) => response.data)
      .finally(() => {
        inFlight.delete(key);
      });
    inFlight.set(key, promise);
  }
  return inFlight.get(key);
}

export function usePublicWebPosts(params = {}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fromApi, setFromApi] = useState(false);
  const paramsKey = JSON.stringify(params || {});

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    (async () => {
      try {
        const payload = await loadPublicWebPosts(params);
        if (cancelled) return;
        const mapped = listCmsDocuments(payload).map((post) => ({
          ...post,
          path: postPath(post),
        }));
        setItems(mapped);
        setFromApi(true);
      } catch {
        if (!cancelled) {
          setItems([]);
          setFromApi(false);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [paramsKey]);

  return { items, loading, fromApi };
}
